export const COMPARE_BY_DIMENSIONS = [
  "agent",
  "mutation",
  "persona",
  "test_case",
  "metadata",
  "run",
  "tag",
  "custom",
] as const

export type CompareByDimension = (typeof COMPARE_BY_DIMENSIONS)[number]
